import * as ACTIONS from 'constant/action/discovery'
import * as ACTION from 'constant/action'
import * as LOADER_ACTIONS from 'constant/action/loader'
import * as PAGINATION from 'constant/pagination'
import * as TABLE from 'constant/table'
import * as NUMBER from 'constant/number'
import buildFileMeta from 'helper/build-file-meta'
import buildImageFile from 'helper/build-image-file'
import isDraft from 'helper/is-draft'
import isPublished from 'helper/is-published'
import { createAction } from 'redux-actions'
import _ from 'lodash'

const updateDiscoveries = createAction(ACTIONS.UPDATE_DISCOVERIES)
const updateDiscoverySubmitting = createAction(LOADER_ACTIONS.UPDATE_DISCOVERY_SUBMITTING)
const updateLoading = createAction(LOADER_ACTIONS.UPDATE_LOADING)
const updatePagination = createAction(ACTIONS.UPDATE_DISCOVERY_PAGINATION)
const updateDiscoverySearchTerm = createAction(ACTIONS.UPDATE_DISCOVERY_SEARCH_TERM)

export const getDiscoveries = (sort = PAGINATION.SORT.DISCOVERIES, direction = PAGINATION.DESCENDING, start = NUMBER.ZERO) => async (dispatch, getState, { discovery }) => {
  dispatch(updateLoading(true))
  dispatch(updatePagination({
    direction,
    sort,
    start
  }))

  const {
    discovery: discoveryState
  } = getState()

  const discoveries = await discovery.getDiscoveries(sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(discoveryState, 'discovery.start'))

  dispatch(updateDiscoveries(discoveries))
  dispatch(updateLoading(false))
}

export const searchDiscoveries = (searchTerm, sort = PAGINATION.SORT.ARTICLES, direction = PAGINATION.DESCENDING, start = NUMBER.ZERO) => async (dispatch, getState, { discovery }) => {
  dispatch(updateDiscoverySearchTerm(searchTerm))

  if (!searchTerm) {
    return dispatch(getDiscoveries())
  }

  dispatch(updateLoading(true))
  dispatch(updatePagination({
    direction,
    sort,
    start
  }))
  const {
    discovery: discoveryState
  } = getState()
  const response = await discovery.searchDiscoveries(searchTerm, sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(discoveryState, 'discovery.start'))
  dispatch(updateDiscoveries(response))
  dispatch(updateLoading(false))
}

export const addNewDiscovery = (discoveryObject) => async (dispatch, getState, { discovery }) => {
  try {
    const {
      auth: {
        user: { uuid }
      }
    } = getState()
    dispatch(updateDiscoverySubmitting(true))
    discoveryObject.image_meta = buildImageFile(discoveryObject.image_meta)

    const {
      file: imageFile,
      meta: imageMeta
    } = buildFileMeta(discoveryObject.image_meta, discoveryObject.title)
    const discoveryIsDraft = isDraft(discoveryObject, true)

    const newDiscovery = {
      ...discoveryObject,
      image_meta: (imageMeta === ACTION.REMOVED ? undefined : imageMeta),
      is_draft: discoveryIsDraft,
      published: isPublished(discoveryIsDraft, discoveryObject.published),
      send_emails: discoveryObject.send_emails === 'true',
      type: 'discovery',
      user_uuid: uuid
    }

    const response = await discovery.addNewDiscovery(newDiscovery)

    if (imageFile) {
      await discovery.uploadFile(response.image_url, imageFile)
    }

    const { discovery: { pagination: { sort, direction, start } } } = getState()

    dispatch(updateDiscoverySubmitting(false))
    dispatch(getDiscoveries(sort, direction, start))

    return newDiscovery
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const editDiscovery = (discoveryObject) => async (dispatch, getState, { discovery }) => {
  try {
    dispatch(updateDiscoverySubmitting(true))

    discoveryObject.image_meta = buildImageFile(discoveryObject.image_meta)

    const {
      file: imageFile,
      meta: imageMeta
    } = buildFileMeta(discoveryObject.image_meta, discoveryObject.title)

    const discoveryIsDraft = isDraft(discoveryObject, true)

    const editedDiscovery = {
      ...discoveryObject,
      image_meta: imageMeta,
      is_draft: discoveryIsDraft,
      published: isPublished(discoveryIsDraft, discoveryObject.published),
      send_emails: discoveryObject.send_emails === 'true'
    }

    const response = await discovery.editDiscovery(editedDiscovery)

    if (imageFile) {
      await discovery.uploadFile(response.image_url, imageFile)
    }

    const { discovery: { pagination: { sort, direction, start } } } = getState()

    dispatch(updateDiscoverySubmitting(false))
    dispatch(getDiscoveries(sort, direction, start))
    return editedDiscovery
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const deleteDiscovery = (uuid) => async (dispatch, getState, { article }) => {
  await article.deleteArticle(uuid, 'discovery')
  const {
    discovery: {
      pagination: {
        sort,
        direction,
        start
      }
    }
  } = getState()
  dispatch(getDiscoveries(sort, direction, start))
}

export const publishDiscovery = (uuid) => async (dispatch, getState, { article }) => {
  await article.publishArticle(uuid)

  const {
    discovery: {
      pagination: {
        sort,
        direction,
        start
      }
    }
  } = getState()

  dispatch(getDiscoveries(sort, direction, start))
}

export const pinDiscovery = (uuid) => async (dispatch, getState, { article }) => {
  await article.pinArticle(uuid)

  const {
    discovery: {
      pagination: {
        sort,
        direction,
        start
      }
    }
  } = getState()

  dispatch(getDiscoveries(sort, direction, start))
}

export const downloadDiscoveries = () => async (dispatch, getState, { discovery }) => {
  try {
    const {
      table: {
        columns: {
          DISCOVERY: columns
        }
      }
    } = getState()
    const { objUrl } = await discovery.downloadDiscoveries(columns)
    window.open(objUrl)
  } catch (error) {
    console.error(error)
  }
}
